import { type App, createApp, ref, watch } from "vue";
import { DsModalAlertModel } from "./ds-modal-alert-model";
import DsModalAlert from "../modal-alert/ds-modal-alert.vue";

/**
 * Mount DS alert component
 */
export function showAlert(props: DsModalAlertModel & { onClosed?: () => void }) {
    const isVisible = ref(true);

    const root = document.createElement("div");
    root.id = "ds-modal-alert-root";

    const originalOnClosed = props.onClosed;
    props.onClosed = () => {
        originalOnClosed?.();
        isVisible.value = false;
        root.remove();
    };

    const alertRef: App<Element> = createApp(DsModalAlert, {
        ...props,
    });

    alertRef.mount(root);

    watch(isVisible, (newVal) => {
        if (!newVal) {
            alertRef?.unmount();
        }
    });

    return {
        isVisible,
    };
}
